'use client';
import { direction, Product, productCardType, ResponseType } from '@/commonTypes';
import React, { useEffect, useMemo, useState } from 'react';
import Api from '@/api';
import { useTranslations } from 'next-intl';
import ProductsServicesContent from '../../product/ProductsContent/productsServicesTemplate';
import { useLayoutContext } from '@/context/LayoutContext';
import { useSearchParams } from 'next/navigation';

interface ContentType {
  data?: ResponseType<productCardType>;
  page?: string | number | null;
  limit?: number;
  params?: any;
  // category?: ResponseType<category>;
  activeCategory?: string | null;
  tagSlug?: string | null;
  type?: 'products' | 'services' | 'shops';
  queryKey?: string;
}

export default function ShopsContent({
  data,
  page,
  limit = 10,
  params,
  // category,
  activeCategory = '',
  tagSlug,
  type = 'shops',
  queryKey = 'category',
}: ContentType) {
  const tCommon = useTranslations('common');
  const [direction, setDirection] = useState<direction>('vertical');
  const { setActiveCategories } = useLayoutContext();
  const searchParams = useSearchParams();

  const sample = {
    id: 1,
    slug: 'yadak-center-pasdaran',

    title: 'مکانیکی تخصصی پاسداران',
    subtitle: 'brake pads',
    description:
      'لنت ترمز جلو برمبو مناسب خودروهای سواری با کیفیت ساخت بالا و عملکرد ترمزگیری عالی.',

    selected: true,
    discount: '20%',
    category: {
      title: 'خدمات و تعمیرگاه‌',
    },
    // image: {
    //   src: '/images/products/brake-pad.jpg',
    //   alt: 'لنت ترمز جلو برمبو اصلی',
    // },

    rating: 4.8,
    distance: '۱.۲ کیلومتر',
    productCount: 2,
    price: 350000,
    services: [
      {
        id: 1,
        title: 'تعویض روغن',
        slug: 'oil-change',
        duration: '30 دقیقه',
        price: '4500000',
      },
      {
        id: 2,
        title: 'دیاگ',
        slug: 'diagnostics',
        duration: '45 دقیقه',
        price: '3500000',
      },
      {
        id: 3,
        title: 'ترمز',
        slug: 'brake',
        duration: '۱ ساعت',
        price: '6000000',
      },
    ],
  };

  const initial = Array.from({ length: 10 }, (_, index) => ({
    ...sample,
    id: index + 1,
    randomNumber: Math.floor(Math.random() * 360),
    count: index,
  }));

  const [pageNumber, setPageNumber] = useState<number | string>(page ? Number(page) : 1);
  const [list, setList] = useState({ response: initial, response_details: { count: 20 } });
  const [categoryList, setCategoryList] = useState([
    { id: 1, title: 'تعمیرگاه و خدمات', slug: 'service-repair' },
    { id: 2, title: 'باتری', slug: 'battery' },
  ]);
  useEffect(() => {
    Api.serviceList({ start: 0, limit: 1000 })
      .then((res) => {
        // setCategoryList(res?.data?.response);
      })
      .catch((err) => {
        console.error('serviceList failed:', err);
      });
  }, []);
  const info = {
    breadcrumb: {
      items: [{ label: 'خانه', to: '/' }, { label: 'فروشگاه‌ها و مراکز ' }],
    },
    hero: {
      title: 'فروشگاه‌ها و مراکز خدماتی',
      text: 'فروشگاه‌های قطعات و تعمیرگاه‌های تأییدشدهٔ کارا در تهران — با امتیاز کاربران، فاصله و ساعت کاری.',
    },
    category: {
      title: 'خدمات و تعمیرگاه‌',
    },
    // services: [
    //   {
    //     id: 1,
    //     title: 'تعویض روغن',
    //     slug: 'oil-change',
    //     duration: '30 دقیقه',
    //     price: '4500000',
    //   },
    //   {
    //     id: 2,
    //     title: 'دیاگ',
    //     slug: 'diagnostics',
    //     duration: '45 دقیقه',
    //     price: '3500000',
    //   },
    //   {
    //     id: 3,
    //     title: 'ترمز',
    //     slug: 'brake',
    //     duration: '۱ ساعت',
    //     price: '6000000',
    //   },
    // ],
  };
  // const [list, setList] = useState(changeData(data));

  // useEffect(() => {
  //   if (data) {
  //     setList(changeData(data));
  //   }
  // }, [data]);
  useEffect(() => {
    setPageNumber(page ? page : 1);
  }, [page]);

  console.log('params1======', params);

  const selectedCategories = useMemo(
    () => searchParams.get(queryKey)?.split(',') ?? [],
    [searchParams.get(queryKey)],
  );

  useEffect(() => {
    setActiveCategories(
      categoryList?.filter((item) => selectedCategories.includes(item.slug)) ?? [],
    );
  }, [categoryList, selectedCategories]);
  return (
    <ProductsServicesContent
      pageNumber={pageNumber}
      setPageNumber={setPageNumber}
      categoryList={categoryList}
      direction={direction}
      setDirection={setDirection}
      infiniteApi={Api.shopList}
      limit={limit}
      list={list}
      setList={setList}
      params={params}
      page={page}
      type={type}
      initialList={data}
      info={info}
      queryKey={queryKey}
      path="/shops"
      showAttSection={false}
      // activeCategory={activeCategory}
    />
  );
}
